module.exports = __webpack_public_path__ + "img/spoke-todo.png.80480a56.webp";